// FlixDetailJsonLd.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import serialize from 'serialize-javascript';
import { withTranslation } from 'react-i18next';

import {
  getCoporation,
  getFlixVideoObject,
  getFlixPreviewVideoObject,
  getFlixHlsVideoObject,
  getPerson,
  getInteractionCounter,
} from '../resource/SchemaObject.js';

export class FlixDetailJsonLd extends React.PureComponent {
  render() {
    const {
      messageId,
      title,
      description,
      senderId,
      senderName,
      durationSecs,
      postedAtUnix,
      isFree,
      viewCount,
      unlockCount,
      likeCount,
      dislikeCount,
      relatedMessageIds,
      assetIds,
      t,
    } = this.props;
    const flixVideoObject = getFlixVideoObject({
      id: messageId,
      assetId: assetIds[0],
      title,
      description: description || title,
      durationSecs,
      postedAtUnix,
      isFree,
      author: {
        '@id': `https://swag.live/user/${senderId}#person`,
      },
      interactionStatistic: [
        { type: 'ViewAction', count: viewCount || 0 },
        { type: 'BuyAction', count: unlockCount || 0 },
        { type: 'LikeAction', count: likeCount || 0 },
        { type: 'DislikeAction', count: dislikeCount || 0 },
      ].map(getInteractionCounter),
      encodings: [{ '@id': `https://swag.live/flix/${messageId}#video-dash` }],
      associatedMedia: {
        '@id': `https://swag.live/flix/${messageId}#preview`,
      },
    });
    const headline = t('seo_cp_video_title', {
      flix_title: flixVideoObject.name,
    });
    const articleBody = t('seo_cp_video_description', {
      cp_name: senderName,
      flix_title: flixVideoObject.name,
      flix_description: flixVideoObject.description,
    });
    return (
      <Helmet>
        <script type="application/ld+json" helmetkey="jsonld">
          {serialize(
            {
              '@context': 'https://schema.org',
              '@graph': [
                {
                  '@type': 'BlogPosting',
                  headline,
                  articleBody,
                  sharedContent: {
                    '@id': flixVideoObject['@id'],
                  },
                  image: [flixVideoObject.thumbnailUrl],
                  datePublished: flixVideoObject.uploadDate,
                  author: {
                    '@id': `https://swag.live/user/${senderId}#person`,
                  },
                  publisher: getCoporation(),
                  relatedLink: relatedMessageIds.map(
                    messageId => `https://swag.live/flix/${messageId}`
                  ),
                },
                flixVideoObject,
                getPerson({ id: senderId, username: senderName }),
                getFlixPreviewVideoObject({
                  id: messageId,
                  assetId: assetIds[0],
                  title,
                  description: description || title,
                  durationSecs: 10,
                  postedAtUnix,
                  author: {
                    '@id': `https://swag.live/user/${senderId}#person`,
                  },
                }),
                getFlixHlsVideoObject({
                  id: messageId,
                  assetId: assetIds[0],
                  title,
                  description: description || title,
                  durationSecs,
                  postedAtUnix,
                  isFree,
                  author: {
                    '@id': `https://swag.live/user/${senderId}#person`,
                  },
                }),
              ],
            },
            { isJSON: true }
          )}
        </script>
      </Helmet>
    );
  }
}

FlixDetailJsonLd.propTypes = {
  messageId: PropTypes.string,
  senderId: PropTypes.string,
  senderName: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  durationSecs: PropTypes.number,
  postedAtUnix: PropTypes.number,
  isFree: PropTypes.bool,
  viewCount: PropTypes.number,
  unlockCount: PropTypes.number,
  likeCount: PropTypes.number,
  dislikeCount: PropTypes.number,
  relatedMessageIds: PropTypes.array,
  assetIds: PropTypes.array,
  t: PropTypes.func.isRequired,
};

FlixDetailJsonLd.defaultProps = {
  messageId: '',
  senderId: '',
  senderName: '',
  title: '',
  description: '',
  durationSecs: 10,
  postedAtUnix: 0,
  isFree: false,
  viewCount: 0,
  unlockCount: 0,
  likeCount: 0,
  dislikeCount: 0,
  relatedMessageIds: [],
  assetIds: [],
};

export default withTranslation()(FlixDetailJsonLd);
